import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SOFTCO_STATIC_WARNING } from "constants/generalConstants";

const SoftCoBanner = () => {
    return (
        <Box
            sx={{
                margin: "5px",
                wordWrap: "justify",
                justifyContent: "flex-end",
            }}
        >
            <Typography color="text.subheader">
                {SOFTCO_STATIC_WARNING}
            </Typography>
        </Box>
    );
};

export default SoftCoBanner;
